// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NotifVarChips{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:6px}.NotifVarChip{font-family:\"Courier New\",Courier,monospace;font-size:11px;padding:2px 8px;border-radius:4px;background:rgba(7,90,174,.08);color:#075aae;border:1px solid rgba(7,90,174,.2);cursor:pointer;white-space:nowrap;transition:background 150ms ease}.NotifVarChip:hover{background:rgba(7,90,174,.15)}", ""]);
// Exports
exports.locals = {
	"primaryColor": "#075aae",
	"lightPrimary": "#3f5868",
	"secondaryColor": "#163683",
	"lightSecondary": "#b8e4f0",
	"darkPrimaryColor": "#103246"
};
module.exports = exports;
